/** Empty string when there is no address — callers hide the CTA on that. */
export function buildSupportMailto(email: string | null | undefined): string {
  const trimmed = (email ?? "").trim();
  if (!trimmed) return "";
  return `mailto:${encodeURIComponent(trimmed).replace(/%40/g, "@")}`;
}
